import AccountList from '../../views-admin/Account/AccountList';
import AccountEdit from '../../views-admin/Account/AccountEdit';

export default [
    {
        path: '/contas',
        name: 'account.list',
        component: AccountList,
        meta: {
            pageTitle: 'Contas',
            breadcrumb: [
                { label: 'Contas' },
            ],
        },
    },
    {
        path: '/contas/cadastro',
        name: 'account.create',
        component: AccountEdit,
        meta: {
            pageTitle: 'Cadastro de Conta',
            breadcrumb: [
                { label: 'Contas', routeName: 'account.list' },
                { label: 'Cadastro de Conta' },
            ],
        },
    },
    {
        path: '/contas/:id',
        name: 'account.edit',
        component: AccountEdit,
        meta: {
            pageTitle: 'Edição de Conta',
            breadcrumb: [
                { label: 'Contas', routeName: 'account.list' },
                { label: 'Edição de Conta' },
            ],
        },
    },
];
